'use client'

import { ReactNode } from 'react'
import { cn } from 'oddle-shop-monorepo.design-system'

interface TypoStyledContentProps {
  htmlContent: string
  className?: string
}

/**
 * A component that applies Typo component styles to HTML content using Tailwind's arbitrary property selectors.
 * This allows HTML tags (h1, h2, h3, h4, p, span) within the content to inherit the same styling
 * as their corresponding Typo components.
 */
export const TypoStyledContent = ({
  htmlContent,
  className,
}: TypoStyledContentProps): ReactNode => {
  return (
    <div
      className={cn(
        'text-body whitespace-pre-wrap',
        // Apply Typo styles to HTML tags using Tailwind's arbitrary property selectors
        // H1 styles (from defaultStyles.h1)
        '[&_h1]:font-headings [&_h1]:text-headings [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:leading-[1.2]',
        // H2 styles (from defaultStyles.h2)
        '[&_h2]:font-headings [&_h2]:text-headings [&_h2]:text-xl [&_h2]:font-bold [&_h2]:leading-[1.25]',
        // H3 styles (from defaultStyles.h3)
        '[&_h3]:font-headings [&_h3]:text-headings [&_h3]:text-lg [&_h3]:font-bold [&_h3]:leading-[1.3]',
        // H4 styles (from defaultStyles.h4)
        '[&_h4]:font-headings [&_h4]:text-headings [&_h4]:text-lg [&_h4]:font-bold [&_h4]:leading-[1.3]',
        // P styles (from defaultStyles.p)
        '[&_p]:font-regular [&_p]:font-body [&_p]:text-body [&_p]:text-base [&_p]:leading-[1.5]',
        // Span styles (from defaultStyles.span)
        '[&_span]:font-regular [&_span]:font-body [&_span]:text-body [&_span]:text-base [&_span]:leading-[1.5]',
        // Additional common tags
        '[&_strong]:font-bold',
        '[&_em]:italic',
        '[&_u]:underline',
        // List styles
        '[&_ol]:mb-2 [&_ul]:mb-2',
        '[&_li]:font-body [&_li]:text-body [&_li]:text-base [&_li]:leading-[1.5]',
        className
      )}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  )
}
